<template>
  <div class="account-login-footer">
    <div class="account-login-footer__title">Don't have an account?</div>
    <span @click.prevent="onCreateAccount" class="account-login-footer__link">
      Create an Account
    </span>
  </div>
</template>

<script src="./footer.js"></script>
<style src="./footer.scss" lang="scss"></style>
